export const getLocalizedString = (id, values)=>{
  const formatMessage = window?.globalIntl?.formatMessage;
  if (formatMessage) {
    return formatMessage({ id }, values);
  }
  // if not found then return the orignal id
  return id;
}